import { Organization, OrganizationEntity } from "./organization";
import { BaseValue } from "../base/base-value";

export type OrgUsingFeatureType = {
  usePayment: boolean;
  usePaymentPayeasy: boolean;
  usePaymentPayPay: boolean;
  useJPKIInternalVerify: boolean;
  useSamlAuth: boolean;
};

export type OrgWithUsingFeaturesType = OrgUsingFeatureType & Organization;

export class OrgWithUsingFeatures extends BaseValue<OrgWithUsingFeaturesType> {
  get usePayment() {
    return this.value.usePayment;
  }

  get useJPKIInternalVerify() {
    return this.value.useJPKIInternalVerify;
  }

  get useSamlAuth() {
    return this.value.useSamlAuth;
  }

  get organization() {
    return new OrganizationEntity(this.value);
  }

  static fromJSON(value: OrgWithUsingFeaturesType) {
    return new OrgWithUsingFeatures(value);
  }
}
